var map = {
	"./Mes.svg": "7/2Y",
	"./ServiceSystem.svg": "kalI",
	"./Tripartite.svg": "q3Sy",
	"./WorkTool.svg": "50mx",
	"./canceledOrder.svg": "hGiI",
	"./custom.svg": "Likm",
	"./doneOrder.svg": "MBxo",
	"./marchOrder.svg": "Sj/g",
	"./msg.svg": "FfkO",
	"./navLR.svg": "iu3b",
	"./newOrder.svg": "t8oq",
	"./news.svg": "zgXw",
	"./pwd.svg": "S6oQ",
	"./site.svg": "Bd3Y",
	"./user.svg": "VdD3"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "90Fk";


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg nonrecursive \.svg$
// module id = 90Fk
// module chunks = 44